(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5584],{

/***/ 68908:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ ContentUpvotesAPI; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20414);
/* harmony import */ var api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24196);



var upvoteContent = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(url, vote) {
        var response, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* .API.post */ .b.post(url, (_tmp.vote = vote, _tmp))
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        response.vote
                    ];
            }
        });
    });
    return function upvoteContent(url, vote) {
        return _ref.apply(this, arguments);
    };
}();
var upvoteQuestion = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(slug, vote) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            return [
                2,
                upvoteContent("/v1/content-upvotes/questions/".concat(slug), vote)
            ];
        });
    });
    return function upvoteQuestion(slug, vote) {
        return _ref.apply(this, arguments);
    };
}();
var upvoteSolution = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(uuid, vote) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            return [
                2,
                upvoteContent("/v1/content-upvotes/solutions/".concat(uuid), vote)
            ];
        });
    });
    return function upvoteSolution(uuid, vote) {
        return _ref.apply(this, arguments);
    };
}();
var upvoteComment = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(uuid, vote) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            return [
                2,
                upvoteContent("/v1/content-upvotes/comments/".concat(uuid), vote)
            ];
        });
    });
    return function upvoteComment(uuid, vote) {
        return _ref.apply(this, arguments);
    };
}();
var upvotePost = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(uuid, vote) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            return [
                2,
                upvoteContent("/v1/content-upvotes/posts/".concat(uuid), vote)
            ];
        });
    });
    return function upvotePost(uuid, vote) {
        return _ref.apply(this, arguments);
    };
}();
var upvoteCourseSection = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(uuid, vote) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            return [
                2,
                upvoteContent("/v1/content-upvotes/course-sections/".concat(uuid), vote)
            ];
        });
    });
    return function upvoteCourseSection(uuid, vote) {
        return _ref.apply(this, arguments);
    };
}();
var upvoteTakehomeSubmission = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(uuid, vote) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            return [
                2,
                upvoteContent("/v1/content-upvotes/takehome-submissions/".concat(uuid), vote)
            ];
        });
    });
    return function upvoteTakehomeSubmission(uuid, vote) {
        return _ref.apply(this, arguments);
    };
}();
var upvoteTakehome = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(uuid, vote) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            return [
                2,
                upvoteContent("/v1/content-upvotes/takehome/".concat(uuid), vote)
            ];
        });
    });
    return function upvoteTakehome(uuid, vote) {
        return _ref.apply(this, arguments);
    };
}();
var ContentUpvotesAPI = {
    upvoteQuestion: upvoteQuestion,
    upvoteSolution: upvoteSolution,
    upvoteComment: upvoteComment,
    upvotePost: upvotePost,
    upvoteCourseSection: upvoteCourseSection,
    upvoteTakehome: upvoteTakehome,
    upvoteTakehomeSubmission: upvoteTakehomeSubmission
};


/***/ }),

/***/ 6505:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ QuestionsAPI; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20414);
/* harmony import */ var api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24196);





var getQuestions = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(limit) {
        var url;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    url = "/v1/questions" + (limit ? "?limit=".concat(limit) : "");
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* .API.get */ .b.get(url)
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function getQuestions(limit) {
        return _ref.apply(this, arguments);
    };
}();
var getQuestionPreview = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(slug) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* .API.get */ .b.get("/v1/questions/preview/".concat(slug))
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function getQuestionPreview(slug) {
        return _ref.apply(this, arguments);
    };
}();
var getQuestionDetail = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(slug) {
        var response, _tmp, question, _tmp1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* .API.get */ .b.get("/v1/questions/detail/".concat(slug))
                    ];
                case 1:
                    response = _state.sent();
                    _tmp = {};
                    if (response.error) return [
                        2,
                        (_tmp.error = response.error, _tmp.question = null, _tmp)
                    ];
                    question = response;
                    question.contentType = "question";
                    _tmp1 = {};
                    return [
                        2,
                        (_tmp1.question = question, _tmp1.error = "", _tmp1)
                    ];
            }
        });
    });
    return function getQuestionDetail(slug) {
        return _ref.apply(this, arguments);
    };
}();
var getPromotedQuestions = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        var questions;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* .API.get */ .b.get("/v1/questions/promoted")
                    ];
                case 1:
                    questions = _state.sent();
                    return [
                        2,
                        questions.map(function(question) {
                            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, question), {
                                contentType: "question"
                            });
                        })
                    ];
            }
        });
    });
    return function getPromotedQuestions() {
        return _ref.apply(this, arguments);
    };
}();
var getAnswer = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(slug) {
        var response;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* .API.get */ .b.get("/v1/questions/answer/".concat(slug))
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        response.answer || ""
                    ];
            }
        });
    });
    return function getAnswer(slug) {
        return _ref.apply(this, arguments);
    };
}();
var getQuestionTags = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* .API.get */ .b.get("/v1/questions/tags")
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function getQuestionTags() {
        return _ref.apply(this, arguments);
    };
}();
// TODO: This is deprecated, don't use anymore.
var getQuestionTypes = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* .API.get */ .b.get("/v1/questions/types")
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function getQuestionTypes() {
        return _ref.apply(this, arguments);
    };
}();
var getHintsAndGotchas = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(slug) {
        var ref, ref1, response, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* .API.get */ .b.get("/v1/questions/hints/".concat(slug))
                    ];
                case 1:
                    response = _state.sent();
                    _tmp = {};
                    return [
                        2,
                        (_tmp.hints = ((ref = response.hints) === null || ref === void 0 ? void 0 : ref.map(function(hint) {
                            return hint.value;
                        })) || [], _tmp.gotchas = ((ref1 = response.gotchas) === null || ref1 === void 0 ? void 0 : ref1.map(function(gotcha) {
                            return gotcha.value;
                        })) || [], _tmp)
                    ];
            }
        });
    });
    return function getHintsAndGotchas(slug) {
        return _ref.apply(this, arguments);
    };
}();
var markCompleted = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(slug, is_completed) {
        var _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* .API.post */ .b.post("/v1/questions/prefs/".concat(slug), (_tmp.is_completed = is_completed, _tmp))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function markCompleted(slug, is_completed) {
        return _ref.apply(this, arguments);
    };
}();
var saveQuestion = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(slug, is_saved) {
        var _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* .API.post */ .b.post("/v1/questions/prefs/".concat(slug), (_tmp.is_saved = is_saved, _tmp))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function saveQuestion(slug, is_saved) {
        return _ref.apply(this, arguments);
    };
}();
var getQuestionStats = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(slug, statsType) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* .API.get */ .b.get("/v1/questions/stats/".concat(slug, "?type=").concat(statsType))
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function getQuestionStats(slug, statsType) {
        return _ref.apply(this, arguments);
    };
}();
var submitFeedback = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(uuid, param) {
        var companyName, companyId, positionTitleName, positionTitleId, askedDate, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    companyName = param.companyName, companyId = param.companyId, positionTitleName = param.positionTitleName, positionTitleId = param.positionTitleId, askedDate = param.askedDate;
                    _tmp = {};
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* .API.post */ .b.post("/v1/questions/feedback/".concat(uuid), (_tmp.uuid = uuid, _tmp.company = companyName, _tmp.company_id = companyId, _tmp.position = positionTitleName, _tmp.position_title_id = positionTitleId, _tmp.asked_date = askedDate, _tmp))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function submitFeedback(uuid, _) {
        return _ref.apply(this, arguments);
    };
}();
var getCategories = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* .API.get */ .b.get("/v1/questions/categories")
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function getCategories() {
        return _ref.apply(this, arguments);
    };
}();
var getAdminQuestions = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* .API.get */ .b.get("/v1/admin/questions")
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function getAdminQuestions() {
        return _ref.apply(this, arguments);
    };
}();
var deleteAdminQuestion = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(id) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* .API["delete"] */ .b["delete"]("/v1/admin/questions/".concat(id))
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function deleteAdminQuestion(id) {
        return _ref.apply(this, arguments);
    };
}();
var getAdminQuestion = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(slug) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* .API.get */ .b.get("/v1/admin/questions/".concat(slug))
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function getAdminQuestion(slug) {
        return _ref.apply(this, arguments);
    };
}();
var saveAdminQuestion = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(question) {
        var apiMethod, url, response, _tmp, _tmp1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    apiMethod = api__WEBPACK_IMPORTED_MODULE_0__/* .API.post */ .b.post;
                    url = "/v1/admin/questions";
                    if (question.id) {
                        apiMethod = api__WEBPACK_IMPORTED_MODULE_0__/* .API.put */ .b.put;
                        url += "/".concat(question.id);
                    }
                    return [
                        4,
                        apiMethod(url, question)
                    ];
                case 1:
                    response = _state.sent();
                    _tmp = {};
                    if (response.error) return [
                        2,
                        (_tmp.question = null, _tmp.error = response.error, _tmp)
                    ];
                    _tmp1 = {};
                    return [
                        2,
                        (_tmp1.question = response, _tmp1.error = "", _tmp1)
                    ];
            }
        });
    });
    return function saveAdminQuestion(question) {
        return _ref.apply(this, arguments);
    };
}();
var adminValidateTestCases = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(request) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* .API.post */ .b.post("/v1/admin/questions/validate-test-cases", request)
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function adminValidateTestCases(request) {
        return _ref.apply(this, arguments);
    };
}();
var QuestionsAPI = {
    getQuestions: getQuestions,
    getQuestionDetail: getQuestionDetail,
    getPromotedQuestions: getPromotedQuestions,
    getAnswer: getAnswer,
    getHintsAndGotchas: getHintsAndGotchas,
    markCompleted: markCompleted,
    saveQuestion: saveQuestion,
    submitFeedback: submitFeedback,
    getCategories: getCategories,
    getQuestionTags: getQuestionTags,
    getQuestionPreview: getQuestionPreview,
    getQuestionTypes: getQuestionTypes,
    getAdminQuestions: getAdminQuestions,
    getAdminQuestion: getAdminQuestion,
    saveAdminQuestion: saveAdminQuestion,
    adminValidateTestCases: adminValidateTestCases,
    getQuestionStats: getQuestionStats,
    deleteAdminQuestion: deleteAdminQuestion
};


/***/ }),

/***/ 98042:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ QuestionBody; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var api_questions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6505);
/* harmony import */ var api_tracking__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5123);
/* harmony import */ var components_system_async_button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(81715);
/* harmony import */ var components_system_button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4642);
/* harmony import */ var components_system_divider__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34070);
/* harmony import */ var components_system_latex__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(89795);
/* harmony import */ var components_system_sticky__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(12074);
/* harmony import */ var components_system_tabs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(88446);
/* harmony import */ var components_system_text_container__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(70865);
/* harmony import */ var hooks_is_mobile__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(77963);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(67294);
/* harmony import */ var users__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(86593);
/* harmony import */ var _recommended_questions__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(61895);
/* harmony import */ var _question_body_module_css__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(95754);
/* harmony import */ var _question_body_module_css__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_question_body_module_css__WEBPACK_IMPORTED_MODULE_14__);















var QuestionBody = function(param) {
    var question = param.question, _showRecommendedQuestions = param.showRecommendedQuestions, showRecommendedQuestions = _showRecommendedQuestions === void 0 ? true : _showRecommendedQuestions;
    var permissionRequired = (0,users__WEBPACK_IMPORTED_MODULE_12__/* .useUpsell */ .$n)().permissionRequired;
    var setTab = (0,components_system_tabs__WEBPACK_IMPORTED_MODULE_8__/* .useTabs */ .Y)().setTab;
    var isMobile = (0,hooks_is_mobile__WEBPACK_IMPORTED_MODULE_10__/* .useIsMobile */ .d)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_11__.useState)([]), hints = ref[0], setHints = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_11__.useState)([]), gotchas = ref1[0], setGotchas = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_11__.useState)(0), visibleHints = ref2[0], setVisibleHints = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_11__.useState)(0), visibleGotchas = ref3[0], setVisibleGotchas = ref3[1];
    var buttonsRef = (0,react__WEBPACK_IMPORTED_MODULE_11__.useRef)(null);
    var lastHintRef = (0,react__WEBPACK_IMPORTED_MODULE_11__.useRef)(null);
    var lastGotchaRef = (0,react__WEBPACK_IMPORTED_MODULE_11__.useRef)(null);
    var scrollIntoView = function(e) {
        window.scrollTo({
            top: e.getBoundingClientRect().top + window.scrollY - buttonsRef.current.offsetHeight + 40,
            behavior: "smooth"
        });
    };
    (0,react__WEBPACK_IMPORTED_MODULE_11__.useEffect)(function() {
        if (visibleHints > 0 && lastHintRef.current) {
            scrollIntoView(lastHintRef.current);
        }
    }, [
        visibleHints
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_11__.useEffect)(function() {
        if (visibleGotchas > 0 && lastGotchaRef.current) {
            scrollIntoView(lastGotchaRef.current);
        }
    }, [
        visibleGotchas
    ]);
    // Reset everything if question changes.
    (0,react__WEBPACK_IMPORTED_MODULE_11__.useEffect)(function() {
        setHints([]);
        setGotchas([]);
        setVisibleHints(0);
        setVisibleGotchas(0);
    }, [
        question
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_system_text_container__WEBPACK_IMPORTED_MODULE_9__/* .TextContainer */ .l, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_question_body_module_css__WEBPACK_IMPORTED_MODULE_14___default().questionBody),
                        "data-question-section": "body",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_system_latex__WEBPACK_IMPORTED_MODULE_6__/* .Latex */ .r, {
                            children: question.body
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_system_sticky__WEBPACK_IMPORTED_MODULE_7__/* .Sticky */ .L, {
                        shadow: true,
                        threshold: 20,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_question_body_module_css__WEBPACK_IMPORTED_MODULE_14___default().buttons),
                            ref: buttonsRef,
                            children: [
                                question.has_hints && (hints.length === 0 || visibleHints < hints.length) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_system_async_button__WEBPACK_IMPORTED_MODULE_3__/* .AsyncButton */ .Z, {
                                    display: isMobile ? "block" : "inline",
                                    type: "outline",
                                    allowClick: function() {
                                        return permissionRequired("question_hint_or_gotcha_view", question.uuid, {
                                            sourceObject: question,
                                            cta: "question.viewHintsOrGotchas"
                                        })();
                                    },
                                    onRequest: function() {
                                        return api_questions__WEBPACK_IMPORTED_MODULE_1__/* .QuestionsAPI.getHintsAndGotchas */ .m.getHintsAndGotchas(question.slug);
                                    },
                                    onSuccess: function(param) {
                                        var hints = param.hints, gotchas = param.gotchas;
                                        setHints(hints);
                                        setGotchas(gotchas);
                                        setVisibleHints(1);
                                        api_tracking__WEBPACK_IMPORTED_MODULE_2__/* .TrackingAPI.hintOrGotchaViewed */ .A.hintOrGotchaViewed(question);
                                    },
                                    onClick: hints.length > 0 ? function() {
                                        setVisibleHints(function(visibleHints) {
                                            return visibleHints + 1;
                                        });
                                        api_tracking__WEBPACK_IMPORTED_MODULE_2__/* .TrackingAPI.hintOrGotchaViewed */ .A.hintOrGotchaViewed(question);
                                    } : undefined,
                                    children: "I need help"
                                }),
                                question.has_gotchas && (gotchas.length === 0 || visibleGotchas < gotchas.length) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_system_async_button__WEBPACK_IMPORTED_MODULE_3__/* .AsyncButton */ .Z, {
                                    display: isMobile ? "block" : "inline",
                                    type: "outline",
                                    allowClick: function() {
                                        return permissionRequired("question_hint_or_gotcha_view", question.uuid, {
                                            sourceObject: question,
                                            cta: "question.viewHintsOrGotchas"
                                        })();
                                    },
                                    onRequest: function() {
                                        return api_questions__WEBPACK_IMPORTED_MODULE_1__/* .QuestionsAPI.getHintsAndGotchas */ .m.getHintsAndGotchas(question.slug);
                                    },
                                    onSuccess: function(param) {
                                        var hints = param.hints, gotchas = param.gotchas;
                                        setHints(hints);
                                        setGotchas(gotchas);
                                        setVisibleGotchas(1);
                                        api_tracking__WEBPACK_IMPORTED_MODULE_2__/* .TrackingAPI.hintOrGotchaViewed */ .A.hintOrGotchaViewed(question);
                                    },
                                    onClick: gotchas.length > 0 ? function() {
                                        setVisibleGotchas(function(visibleGotchas) {
                                            return visibleGotchas + 1;
                                        });
                                        api_tracking__WEBPACK_IMPORTED_MODULE_2__/* .TrackingAPI.hintOrGotchaViewed */ .A.hintOrGotchaViewed(question);
                                    } : undefined,
                                    children: "I've got an answer"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_system_button__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .z, {
                                    color: "orange",
                                    display: isMobile ? "block" : "inline",
                                    onClick: function() {
                                        return setTab("Solution");
                                    },
                                    children: "Show solution"
                                })
                            ]
                        })
                    }),
                    hints.slice(0, visibleHints).map(function(hint, index) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            "data-question-section": "hint",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    ref: index === visibleHints - 1 ? lastHintRef : undefined,
                                    className: (_question_body_module_css__WEBPACK_IMPORTED_MODULE_14___default().ref)
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_system_divider__WEBPACK_IMPORTED_MODULE_5__/* .Divider */ .i, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("strong", {
                                        children: [
                                            "Hint #",
                                            index + 1
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_system_latex__WEBPACK_IMPORTED_MODULE_6__/* .Latex */ .r, {
                                    children: hint
                                })
                            ]
                        }, index);
                    }),
                    gotchas.slice(0, visibleGotchas).map(function(gotcha, index) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            "data-question-section": "gotcha",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    ref: index === visibleGotchas - 1 ? lastGotchaRef : undefined,
                                    className: (_question_body_module_css__WEBPACK_IMPORTED_MODULE_14___default().ref)
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_system_divider__WEBPACK_IMPORTED_MODULE_5__/* .Divider */ .i, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("strong", {
                                        children: [
                                            "Gotcha #",
                                            index + 1
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_system_latex__WEBPACK_IMPORTED_MODULE_6__/* .Latex */ .r, {
                                    children: gotcha
                                })
                            ]
                        }, index);
                    })
                ]
            }),
            showRecommendedQuestions && question.recommended_questions.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_system_divider__WEBPACK_IMPORTED_MODULE_5__/* .Divider */ .i, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_recommended_questions__WEBPACK_IMPORTED_MODULE_13__/* .RecommendedQuestions */ .o, {
                        questions: question.recommended_questions,
                        collapsible: true,
                        initialCollapsed: true,
                        trackingComponent: "questionDetail"
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 97526:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ Solution; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(20414);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var api_content_upvotes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68908);
/* harmony import */ var api_questions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6505);
/* harmony import */ var api_tracking__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5123);
/* harmony import */ var components_system_button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4642);
/* harmony import */ var components_system_latex__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89795);
/* harmony import */ var components_system_spinner__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52852);
/* harmony import */ var components_system_tabs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(88446);
/* harmony import */ var components_system_text_container__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(70865);
/* harmony import */ var components_system_vote__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(89049);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(67294);
/* harmony import */ var users__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(86593);
/* harmony import */ var _solution_module_css__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(49634);
/* harmony import */ var _solution_module_css__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_solution_module_css__WEBPACK_IMPORTED_MODULE_14__);















var Solution = function(param) {
    var question = param.question;
    var ref = (0,users__WEBPACK_IMPORTED_MODULE_11__/* .useAuth */ .aC)(), user = ref.user, hasPermission = ref.hasPermission;
    var setTab = (0,components_system_tabs__WEBPACK_IMPORTED_MODULE_7__/* .useTabs */ .Y)().setTab;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)(""), solution = ref1[0], setSolution = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)(false), loading = ref2[0], setLoading = ref2[1];
    (0,react__WEBPACK_IMPORTED_MODULE_10__.useEffect)(function() {
        var getAnswer = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(function() {
                var solution;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_13__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            setLoading(true);
                            return [
                                4,
                                api_questions__WEBPACK_IMPORTED_MODULE_2__/* .QuestionsAPI.getAnswer */ .m.getAnswer(question.slug)
                            ];
                        case 1:
                            solution = _state.sent();
                            setSolution(solution);
                            setLoading(false);
                            return [
                                2
                            ];
                    }
                });
            });
            return function getAnswer() {
                return _ref.apply(this, arguments);
            };
        }();
        if (question.has_solution && hasPermission("question_solution_view", question.slug)) {
            getAnswer();
        }
        api_tracking__WEBPACK_IMPORTED_MODULE_3__/* .TrackingAPI.solutionViewed */ .A.solutionViewed(question);
    }, [
        question.slug
    ]);
    if (loading) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_system_spinner__WEBPACK_IMPORTED_MODULE_6__/* .Spinner */ .$, {
        size: "sm",
        text: "Loading solution"
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_solution_module_css__WEBPACK_IMPORTED_MODULE_14___default().container),
        children: [
            solution !== "" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_system_text_container__WEBPACK_IMPORTED_MODULE_8__/* .TextContainer */ .l, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_system_latex__WEBPACK_IMPORTED_MODULE_5__/* .Latex */ .r, {
                    children: solution
                })
            }),
            !question.has_solution && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        children: "We don't have an official solution yet. In the meantime, you can check out the user submissions and the comments. Or submit your own solution for discussion!"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_solution_module_css__WEBPACK_IMPORTED_MODULE_14___default().buttons),
                        children: [
                            question.languages.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_system_button__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .z, {
                                color: "orangeLight",
                                onClick: function() {
                                    return setTab("User submissions");
                                },
                                children: "View user submissions"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_system_button__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .z, {
                                color: "orangeLight",
                                href: "#comment-list",
                                children: "View comments"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(users__WEBPACK_IMPORTED_MODULE_11__/* .Upsell */ .QH, {
                cta: "question.viewSolution",
                sourceObject: question,
                barrier: question.has_solution && solution === ""
            }),
            solution !== "" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_solution_module_css__WEBPACK_IMPORTED_MODULE_14___default().vote),
                children: user.loggedIn && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            children: "Was this solution useful?"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_system_vote__WEBPACK_IMPORTED_MODULE_9__/* .Vote */ .A, {
                            upvotes: question.solution_upvotes,
                            userVote: question.solution_vote,
                            onVote: function(vote) {
                                return api_content_upvotes__WEBPACK_IMPORTED_MODULE_1__/* .ContentUpvotesAPI.upvoteSolution */ .S.upvoteSolution(question.slug, vote);
                            },
                            hideVote: !user.isAdmin
                        })
                    ]
                })
            })
        ]
    });
};


/***/ }),

/***/ 87834:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ QuestionLink; },
/* harmony export */   "l": function() { return /* binding */ QuestionLinkList; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var api_tracking__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5123);
/* harmony import */ var components_system_pilltag__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94390);
/* harmony import */ var components_system_pilltag_group__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8681);
/* harmony import */ var icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63009);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var types_levels__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(38194);
/* harmony import */ var _question_link_list_module_css__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85285);
/* harmony import */ var _question_link_list_module_css__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_question_link_list_module_css__WEBPACK_IMPORTED_MODULE_7__);









var QuestionLinkList = function(param) {
    var questions = param.questions, trackingComponent = param.trackingComponent, trackingExtraData = param.trackingExtraData;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_question_link_list_module_css__WEBPACK_IMPORTED_MODULE_7___default().container),
        children: questions.map(function(question, ranking) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(QuestionLink, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
                ranking: ranking,
                trackingComponent: trackingComponent,
                trackingExtraData: trackingExtraData
            }, question), question.slug);
        })
    });
};
var QuestionLink = function(param) {
    var uuid = param.uuid, slug = param.slug, title = param.title, summary = param.summary, tags = param.tags, level = param.level, ranking = param.ranking, trackingComponent = param.trackingComponent, trackingExtraData = param.trackingExtraData;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
        prefetch: false,
        href: "/questions/".concat(slug),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
            className: (_question_link_list_module_css__WEBPACK_IMPORTED_MODULE_7___default().link),
            onClick: function() {
                api_tracking__WEBPACK_IMPORTED_MODULE_1__/* .TrackingAPI.recommendedQuestionClicked */ .A.recommendedQuestionClicked({
                    ranking: ranking,
                    uuid: uuid,
                    component: trackingComponent,
                    extraData: trackingExtraData
                });
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_question_link_list_module_css__WEBPACK_IMPORTED_MODULE_7___default().content),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                            children: title
                        }),
                        summary && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            children: summary
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_system_pilltag_group__WEBPACK_IMPORTED_MODULE_3__/* .PillTagGroup */ .s, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_system_pilltag__WEBPACK_IMPORTED_MODULE_2__/* .PillTag */ .j, {
                                    color: types_levels__WEBPACK_IMPORTED_MODULE_6__/* .difficultyLevelColors */ .gw[level],
                                    children: types_levels__WEBPACK_IMPORTED_MODULE_6__/* .difficultyLevelNames */ .vz[level]
                                }),
                                (tags || []).map(function(tag) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_system_pilltag__WEBPACK_IMPORTED_MODULE_2__/* .PillTag */ .j, {
                                        color: "greyLight",
                                        children: tag.name
                                    }, tag.id);
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(icons__WEBPACK_IMPORTED_MODULE_4__/* .ChevronRightIcon */ .XC, {})
            ]
        })
    });
};


/***/ }),

/***/ 61895:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ RecommendedQuestions; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(20414);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var api_questions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6505);
/* harmony import */ var components_questions_question_link_list__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87834);
/* harmony import */ var components_system_button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4642);
/* harmony import */ var components_system_content_placeholder__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62836);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);
/* harmony import */ var _recommended_questions_module_css__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(11882);
/* harmony import */ var _recommended_questions_module_css__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_recommended_questions_module_css__WEBPACK_IMPORTED_MODULE_8__);









var RecommendedQuestions = function(param) {
    var tmp = param.questions, initialQuestions = tmp === void 0 ? noQuestions : tmp, _collapsible = param.collapsible, collapsible = _collapsible === void 0 ? false : _collapsible, _initialCollapsed = param.initialCollapsed, initialCollapsed = _initialCollapsed === void 0 ? false : _initialCollapsed, trackingComponent = param.trackingComponent, _plainList = param.plainList, plainList = _plainList === void 0 ? false : _plainList;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(initialQuestions), questions = ref[0], setQuestions = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(initialQuestions.length === 0), loading = ref1[0], setLoading = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(initialCollapsed), collapsed = ref2[0], setCollapsed = ref2[1];
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(function() {
        // If no questions are provided externally then get recommended questions from the API.
        // If the user is logged in then these will be provided by the recommender based on their preferences.
        var getRecommendedQuestions = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function() {
                var questions;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                api_questions__WEBPACK_IMPORTED_MODULE_1__/* .QuestionsAPI.getQuestions */ .m.getQuestions(5)
                            ];
                        case 1:
                            questions = _state.sent();
                            setQuestions(questions);
                            setLoading(false);
                            return [
                                2
                            ];
                    }
                });
            });
            return function getRecommendedQuestions() {
                return _ref.apply(this, arguments);
            };
        }();
        if (questions.length === 0) {
            getRecommendedQuestions();
        }
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(function() {
        setQuestions(initialQuestions);
        if (initialCollapsed) setCollapsed(true);
    }, [
        initialQuestions
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_recommended_questions_module_css__WEBPACK_IMPORTED_MODULE_8___default().container),
        children: [
            !plainList && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    " ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_recommended_questions_module_css__WEBPACK_IMPORTED_MODULE_8___default().title),
                        children: "Recommended questions for you"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        children: "Personalized based on your user activity, skill level, and preferences."
                    })
                ]
            }),
            loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_system_content_placeholder__WEBPACK_IMPORTED_MODULE_4__/* .ContentPlaceholder */ .r, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    !collapsed && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_questions_question_link_list__WEBPACK_IMPORTED_MODULE_2__/* .QuestionLinkList */ .l, {
                        questions: questions,
                        trackingComponent: trackingComponent
                    }),
                    collapsible && collapsed && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_system_button__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .z, {
                        size: "sm",
                        color: "greyLight",
                        onClick: function() {
                            return setCollapsed(!collapsed);
                        },
                        children: "View recommended questions"
                    })
                ]
            })
        ]
    });
};
var noQuestions = [];


/***/ }),

/***/ 62836:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ ContentPlaceholder; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _content_placeholder_module_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5306);
/* harmony import */ var _content_placeholder_module_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_content_placeholder_module_css__WEBPACK_IMPORTED_MODULE_1__);



var ContentPlaceholder = function(param) {
    var _lines = param.lines, lines = _lines === void 0 ? 5 : _lines;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_content_placeholder_module_css__WEBPACK_IMPORTED_MODULE_1___default().container),
        children: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(Array(lines).keys()).map(function(_, index) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_content_placeholder_module_css__WEBPACK_IMPORTED_MODULE_1___default().line)
            }, index);
        })
    });
};


/***/ }),

/***/ 34070:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ Divider; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44868);
/* harmony import */ var _divider_module_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45062);
/* harmony import */ var _divider_module_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_divider_module_css__WEBPACK_IMPORTED_MODULE_2__);




var Divider = function(param) {
    var maxWidth = param.maxWidth, _size = param.size, size = _size === void 0 ? "md" : _size, _align = param.align, align = _align === void 0 ? "center" : _align, children = param.children;
    var style = {
        maxWidth: maxWidth ? maxWidth : undefined,
        margin: "var(--iq-gap-".concat(size, ") auto")
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_divider_module_css__WEBPACK_IMPORTED_MODULE_2___default().divider),
        style: style,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (0,utils__WEBPACK_IMPORTED_MODULE_3__/* .classNames */ .AK)([
                (_divider_module_css__WEBPACK_IMPORTED_MODULE_2___default().children),
                (_divider_module_css__WEBPACK_IMPORTED_MODULE_2___default())[size],
                (_divider_module_css__WEBPACK_IMPORTED_MODULE_2___default())[align]
            ]),
            children: children
        })
    });
};


/***/ }),

/***/ 89795:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ Latex; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var katex_dist_katex_min_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97604);
/* harmony import */ var katex_dist_katex_min_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(katex_dist_katex_min_css__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_latex_next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30760);




var Latex = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_latex_next__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props));
};


/***/ }),

/***/ 8681:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ PillTagGroup; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _pilltag_group_module_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12195);
/* harmony import */ var _pilltag_group_module_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_pilltag_group_module_css__WEBPACK_IMPORTED_MODULE_2__);



var PillTagGroup = function(param) {
    var children = param.children, maxVisible = param.maxVisible;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), viewAll = ref[0], setViewAll = ref[1];
    var count = react__WEBPACK_IMPORTED_MODULE_1__.Children.count(children);
    var visible = maxVisible || count;
    var extra = Math.max(0, count - visible);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_pilltag_group_module_css__WEBPACK_IMPORTED_MODULE_2___default().pilltagGroup),
        children: [
            viewAll ? children : react__WEBPACK_IMPORTED_MODULE_1__.Children.toArray(children).slice(0, visible),
            extra > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                className: (_pilltag_group_module_css__WEBPACK_IMPORTED_MODULE_2___default().viewAll),
                onClick: function() {
                    return setViewAll(viewAll ? false : true);
                },
                children: viewAll ? "show less" : "+".concat(extra, " more")
            })
        ]
    });
};


/***/ }),

/***/ 12074:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ Sticky; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var hooks_is_mobile__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77963);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44868);
/* harmony import */ var _sticky_module_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82912);
/* harmony import */ var _sticky_module_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_sticky_module_css__WEBPACK_IMPORTED_MODULE_4__);





var HEADER_HEIGHT = 80;
var Sticky = function(param) {
    var _threshold = param.threshold, threshold = _threshold === void 0 ? 20 : _threshold, _shadow = param.shadow, shadow = _shadow === void 0 ? false : _shadow, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, _zIndexOffset = param.zIndexOffset, zIndexOffset = _zIndexOffset === void 0 ? 0 : _zIndexOffset, children = param.children;
    var isMobile = (0,hooks_is_mobile__WEBPACK_IMPORTED_MODULE_1__/* .useIsMobile */ .d)();
    if (disabled) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: children
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        style: {
            top: (isMobile ? 0 : HEADER_HEIGHT) + threshold,
            zIndex: "calc(var(--iq-z-index-sticky) + ".concat(zIndexOffset, ")")
        },
        className: (0,utils__WEBPACK_IMPORTED_MODULE_3__/* .classNames */ .AK)([
            (_sticky_module_css__WEBPACK_IMPORTED_MODULE_4___default().sticky),
            shadow && (_sticky_module_css__WEBPACK_IMPORTED_MODULE_4___default().hasShadow)
        ]),
        children: [
            children,
            shadow && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        style: {
                            height: threshold
                        },
                        className: (_sticky_module_css__WEBPACK_IMPORTED_MODULE_4___default().topShadow)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        style: {
                            height: threshold
                        },
                        className: (_sticky_module_css__WEBPACK_IMPORTED_MODULE_4___default().bottomShadow)
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 88446:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ useTabs; },
/* harmony export */   "m": function() { return /* binding */ Tabs; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44868);
/* harmony import */ var _colors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47655);
/* harmony import */ var _tabs_module_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76448);
/* harmony import */ var _tabs_module_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_tabs_module_css__WEBPACK_IMPORTED_MODULE_4__);





var TabsContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
    setTab: function() {}
});
var useTabs = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(TabsContext);
};
function Tabs(param) {
    var tabs = param.tabs, initialTab = param.initialTab, _color = param.color, color = _color === void 0 ? "orange" : _color, _size = param.size, size = _size === void 0 ? "md" : _size, onChange = param.onChange;
    var ref;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), selected = ref1[0], setSelected = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var labels = tabs.map(function(param) {
            var label = param.label;
            return label;
        });
        if (!labels.includes(selected)) setSelected(initialTab || tabs[0].label);
    }, [
        tabs
    ]);
    var handleTabChange = function(label) {
        var labels = tabs.map(function(param) {
            var _$label = param.label;
            return _$label;
        });
        if (labels.includes(label)) setSelected(label);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (initialTab) setSelected(initialTab);
    }, [
        initialTab
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(TabsContext.Provider, {
        value: {
            setTab: function(label) {
                handleTabChange(label);
                window.scrollTo({
                    top: 0,
                    behavior: "smooth"
                });
            }
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (0,utils__WEBPACK_IMPORTED_MODULE_3__/* .classNames */ .AK)([
                    (_tabs_module_css__WEBPACK_IMPORTED_MODULE_4___default().tabs),
                    (_tabs_module_css__WEBPACK_IMPORTED_MODULE_4___default())[size]
                ]),
                children: tabs.map(function(tab) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        className: (0,utils__WEBPACK_IMPORTED_MODULE_3__/* .classNames */ .AK)([
                            (_tabs_module_css__WEBPACK_IMPORTED_MODULE_4___default().tabButton),
                            tab.label === selected && (_tabs_module_css__WEBPACK_IMPORTED_MODULE_4___default().selected),
                            (_tabs_module_css__WEBPACK_IMPORTED_MODULE_4___default())[size], 
                        ]),
                        style: tab.label === selected ? {
                            borderColor: _colors__WEBPACK_IMPORTED_MODULE_2__/* .cssColorValues */ .b[color]
                        } : undefined,
                        disabled: tab.disabled,
                        onClick: function() {
                            if (!tab.allowClick || tab.allowClick()) {
                                setSelected(tab.label);
                                if (onChange) onChange(tab.label);
                                if (tab.onClick) tab.onClick();
                            }
                        },
                        children: tab.label
                    }, tab.label);
                })
            }),
            ((ref = tabs.find(function(param) {
                var label = param.label;
                return label === selected;
            })) === null || ref === void 0 ? void 0 : ref.children) || null
        ]
    });
}


/***/ }),

/***/ 89049:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ Vote; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var icons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63009);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var types_vote__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47260);
/* harmony import */ var users__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86593);
/* harmony import */ var utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(44868);
/* harmony import */ var _async_button__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(81715);
/* harmony import */ var _tooltip__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45821);
/* harmony import */ var _vote_module_css__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(16082);
/* harmony import */ var _vote_module_css__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_vote_module_css__WEBPACK_IMPORTED_MODULE_8__);









var Vote = function(param) {
    var initialUpvotes = param.upvotes, tmp = param.userVote, initialUserVote = tmp === void 0 ? types_vote__WEBPACK_IMPORTED_MODULE_3__/* .VoteType.Novote */ .d.Novote : tmp, minUpvotes = param.minUpvotes, onVote = param.onVote, onVoteSuccess = param.onVoteSuccess, _layout = param.layout, layout = _layout === void 0 ? "horizontal" : _layout, _hideVote = param.hideVote, hideVote = _hideVote === void 0 ? false : _hideVote, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled;
    var loginRequired = (0,users__WEBPACK_IMPORTED_MODULE_4__/* .useUpsell */ .$n)().loginRequired;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(initialUpvotes), upvotes = ref[0], setUpvotes = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(initialUserVote), userVote = ref1[0], setUserVote = ref1[1];
    // Update internal state if props change.
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        return setUserVote(initialUserVote);
    }, [
        initialUserVote
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        return setUpvotes(initialUpvotes);
    }, [
        initialUpvotes
    ]);
    var upvoted = userVote === types_vote__WEBPACK_IMPORTED_MODULE_3__/* .VoteType.Upvote */ .d.Upvote;
    var downvoted = userVote === types_vote__WEBPACK_IMPORTED_MODULE_3__/* .VoteType.Downvote */ .d.Downvote;
    var handleVoteSuccess = function(newUserVote) {
        // Update internal state after voting.
        var newUpvotes = upvotes - userVote + newUserVote;
        setUpvotes(newUpvotes);
        setUserVote(newUserVote);
        if (onVoteSuccess) onVoteSuccess(newUserVote, newUpvotes);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,utils__WEBPACK_IMPORTED_MODULE_7__/* .classNames */ .AK)([
            (_vote_module_css__WEBPACK_IMPORTED_MODULE_8___default().vote),
            (_vote_module_css__WEBPACK_IMPORTED_MODULE_8___default())[layout]
        ]),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_tooltip__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                tipText: upvoted ? "Remove Upvote" : "Upvote",
                disabled: disabled,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_async_button__WEBPACK_IMPORTED_MODULE_5__/* .AsyncButton */ .Z, {
                    title: upvoted ? "Remove Upvote" : "Upvote",
                    name: "upvote",
                    type: "icon",
                    allowClick: loginRequired({
                        cta: "vote"
                    }),
                    onRequest: function() {
                        return onVote(upvoted ? types_vote__WEBPACK_IMPORTED_MODULE_3__/* .VoteType.Novote */ .d.Novote : types_vote__WEBPACK_IMPORTED_MODULE_3__/* .VoteType.Upvote */ .d.Upvote);
                    },
                    onSuccess: handleVoteSuccess,
                    disabled: disabled,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(icons__WEBPACK_IMPORTED_MODULE_1__/* .ArrowUpIcon */ .Hf, {
                        color: upvoted ? "green" : "greyLight"
                    })
                })
            }),
            !hideVote && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_vote_module_css__WEBPACK_IMPORTED_MODULE_8___default().voteCount),
                children: minUpvotes === undefined ? upvotes : Math.max(minUpvotes, upvotes)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_tooltip__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                tipText: downvoted ? "Remove Downvote" : "Downvote",
                disabled: disabled,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_async_button__WEBPACK_IMPORTED_MODULE_5__/* .AsyncButton */ .Z, {
                    title: downvoted ? "Remove Downvote" : "Downvote",
                    name: "downvote",
                    type: "icon",
                    allowClick: loginRequired({
                        cta: "vote"
                    }),
                    onRequest: function() {
                        return onVote(downvoted ? types_vote__WEBPACK_IMPORTED_MODULE_3__/* .VoteType.Novote */ .d.Novote : types_vote__WEBPACK_IMPORTED_MODULE_3__/* .VoteType.Downvote */ .d.Downvote);
                    },
                    onSuccess: handleVoteSuccess,
                    disabled: disabled,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(icons__WEBPACK_IMPORTED_MODULE_1__/* .ArrowDownIcon */ .ve, {
                        color: downvoted ? "red" : "greyLight"
                    })
                })
            })
        ]
    });
};


/***/ }),

/***/ 38194:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a8": function() { return /* binding */ difficultyLevelOptions; },
/* harmony export */   "gw": function() { return /* binding */ difficultyLevelColors; },
/* harmony export */   "l9": function() { return /* binding */ difficultyLevels; },
/* harmony export */   "vz": function() { return /* binding */ difficultyLevelNames; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14924);

var difficultyLevels = {
    Easy: 1,
    Medium: 2,
    Hard: 3
};
var _obj;
var difficultyLevelNames = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, difficultyLevels.Easy, "Easy"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, difficultyLevels.Medium, "Medium"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, difficultyLevels.Hard, "Hard"), _obj);
var _obj1;
var difficultyLevelColors = (_obj1 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj1, difficultyLevels.Easy, "green"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj1, difficultyLevels.Medium, "orange"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj1, difficultyLevels.Hard, "red"), _obj1);
var difficultyLevelOptions = [
    {
        value: difficultyLevels.Easy,
        label: difficultyLevelNames[difficultyLevels.Easy]
    },
    {
        value: difficultyLevels.Medium,
        label: difficultyLevelNames[difficultyLevels.Medium]
    },
    {
        value: difficultyLevels.Hard,
        label: difficultyLevelNames[difficultyLevels.Hard]
    }, 
];


/***/ }),

/***/ 47260:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ VoteType; }
/* harmony export */ });
var VoteType = {
    Upvote: 1,
    Downvote: -1,
    Novote: 0
};


/***/ }),

/***/ 95754:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"buttons":"question_body_buttons__Y8ySd","questionBody":"question_body_questionBody__sMZMH","ref":"question_body_ref__39kuS"};

/***/ }),

/***/ 49634:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"solution_container__lebx7","buttons":"solution_buttons__dkokG","vote":"solution_vote__S8the"};

/***/ }),

/***/ 85285:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"question_link_list_container__DyAIS","link":"question_link_list_link__YgMDs","content":"question_link_list_content__ILR6a"};

/***/ }),

/***/ 11882:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"recommended_questions_container__Vugp_","title":"recommended_questions_title__03Vi9","chevron":"recommended_questions_chevron__Y4X0y"};

/***/ }),

/***/ 5306:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"content_placeholder_container__1HHjG","line":"content_placeholder_line__GgkD0","shimmer":"content_placeholder_shimmer__0zTdV"};

/***/ }),

/***/ 45062:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"divider":"divider_divider__TDBAz","children":"divider_children__Tybyn","sm":"divider_sm__PazsW","md":"divider_md__yK10n","lg":"divider_lg__P_HO8","center":"divider_center__XNVE_","left":"divider_left__bbB4n","right":"divider_right__jS9lw"};

/***/ }),

/***/ 12195:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"pilltagGroup":"pilltag_group_pilltagGroup__PQeq8","viewAll":"pilltag_group_viewAll__BagPb"};

/***/ }),

/***/ 82912:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sticky":"sticky_sticky__ijZEX","hasShadow":"sticky_hasShadow__5duxm","topShadow":"sticky_topShadow__uSPN9","bottomShadow":"sticky_bottomShadow__VZHpf"};

/***/ }),

/***/ 76448:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tabs":"tabs_tabs__bB9e5","sm":"tabs_sm__Avnnu","md":"tabs_md__b9P7e","lg":"tabs_lg__g9iAs","tabButton":"tabs_tabButton__qb4ok","selected":"tabs_selected___PWKS"};

/***/ }),

/***/ 16082:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"vote":"vote_vote__l1pUD","horizontal":"vote_horizontal__XnHZg","vertical":"vote_vertical__Ky8vD","upvotes":"vote_upvotes__8usC4"};

/***/ })

}]);